import { render, staticRenderFns } from "./TemplateDigitalSignage.vue?vue&type=template&id=7e8e468a&scoped=true&"
import script from "./TemplateDigitalSignage.vue?vue&type=script&lang=js&"
export * from "./TemplateDigitalSignage.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDigitalSignage.vue?vue&type=style&index=0&id=7e8e468a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8e468a",
  null
  
)

export default component.exports